/**
 * Enum with some status, state, result, etc type
 */
export enum ColorTypeEnum {
  DEFAULT = 'default',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  GRAY = 'gray'
}
